import urls from '../api_urls/role'
import { _post } from '@/axios/request'

// 获取角色列表
export function getTableData (params) {
  return _post(urls.GET_ROLE_LIST, params)
}

// 获取角色所有权限
export function getAllAuth () {
  return _post(urls.GET_ALL_AUTH)
}

// 获取角色详情权限
export function getDetails (params = {id: 2}) {
  return _post(urls.GET_ROLE_DETAILS, params)
}

// 保存角色
export function saveRole (params) {
  return _post(urls.SAVE_ROLE, params)
}

// 更新角色
export function updateRole (params) {
  return _post(urls.UPDATE_ROLE, params)
}

// 远程搜索角色
export function filterRole (params) {
  return _post(urls.FILTER_ROLE, params)
}

// 远程搜索角色(可选择状态，模糊搜索默认100条)
export function findFilterRoles (params) {
  return _post(urls.FIND_FILTER_ROLE, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/role.js